import script from "./ArgonLoadingButton.vue?vue&type=script&setup=true&lang=js"
export * from "./ArgonLoadingButton.vue?vue&type=script&setup=true&lang=js"

import "./ArgonLoadingButton.vue?vue&type=style&index=0&id=49e47b3f&lang=scss"

const __exports__ = script;

export default __exports__